import React from 'react';
import { Box } from '@mui/material';
import Slider from 'react-slick';
import ArrowButton from '../../atoms/arrow-button/arrowButton';
import './modalForCard.scss';

interface IModalForCardProps {
    data?: any;
    children: any;
}

const ModalForCard = ({ data, children }: IModalForCardProps) => {
    const settings = {
        dots: true,
        autoplay: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <ArrowButton />,
        prevArrow: <ArrowButton />,
    };
    return (
        <Box className="m_modalforcard">
            <div className="m_modalforcard__modalslider">
                {data && (
                    <>
                        {data[0]}
                        {data.slice(1) && data.slice(1).length > 1 ? (
                            <Slider {...settings}>
                                {data.slice(1).map((slide, index) => (
                                    <div
                                        key={index}
                                        className="m_modalforcard__modalslide"
                                    >
                                        {slide}
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <div className="m_modalforcard__modalslide">
                                {data.slice(1)[0]}
                            </div>
                        )}
                    </>
                )}
            </div>
            {children}
        </Box>
    );
};

export default ModalForCard;
